import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/slcp/(pages)/(list)/my-own')({
  component: lazyRouteComponent(
    () => import('../../../-components/SlcpMyOwnLayout'),
    'SlcpMyOwnLayout',
  ),
});
